import { Box, Hidden, Theme, Typography } from '@mui/material';

import { Skeleton } from '@/components';
import { Chapter, Episode } from '@/types';

interface ChapterInfoProps {
  episode: Episode;
  chapter: Chapter;
  isLoading?: boolean;
}

export const ChapterInfo = ({
  episode,
  chapter,
  isLoading,
}: ChapterInfoProps) => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.coverContainer}>
        {isLoading ? (
          <Skeleton variant="rectangular" />
        ) : (
          <Box
            component="img"
            sx={styles.cover}
            src={episode.companyLogo}
            alt="company logo"
          />
        )}
      </Box>
      <Hidden smDown>
        <Box sx={styles.infoContainer}>
          {isLoading ? (
            <>
              <Skeleton height={32} />
              <Skeleton height={24} width={120} />
            </>
          ) : (
            <>
              <Typography variant="body2SemiBold" noWrap>
                {episode.name}
              </Typography>
              <Typography variant="body3" noWrap>
                {chapter.name}
              </Typography>
            </>
          )}
        </Box>
      </Hidden>
    </Box>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
  },
  coverContainer: (theme: Theme) => ({
    alignItems: 'center',
    display: 'flex',
    height: 90,
    justifyContent: 'center',
    width: 90,
    [theme.breakpoints.down('sm')]: {
      height: 66,
      width: 66,
    },
  }),
  cover: (theme: Theme) => ({
    display: 'block',
    height: 90,
    width: 90,
    [theme.breakpoints.down('sm')]: {
      height: 66,
      width: 66,
    },
  }),
  infoContainer: (theme: Theme) => ({
    height: 90,
    pl: 2.5,
    pt: 3,
    width: '75%',
    [theme.breakpoints.down('sm')]: {
      height: 66,
    },
  }),
};
